/* eslint-disable no-shadow */
export enum TBackgroundType {
  Gradient,
  White,
  Gray,
  Login,
}
